import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectProfile } from './profile.selector.ts';

export const selectProfileName = createMemoizedSelector(
  selectProfile,
  (currentProfile): string | undefined => currentProfile?.name
);
